module.exports = __webpack_public_path__ + "img/check-circle-white.25f49447.svg";